.d3{aspect-ratio:1/1;}